export default "__VITE_ASSET__O8O4$g2v__"